var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 107.73 100.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#495e67;}.cls-2{fill:#5c7581;}.cls-3{fill:#5b7480;}.cls-4{fill:#4a5f6a;}.cls-5{fill:url(#radial-gradient);}.cls-6{fill:#a2c0ed;mix-blend-mode:multiply;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 56.78,
    cy: 48.43,
    r: 46.56,
    gradientTransform: "matrix(0.95, -0.31, 0.19, 0.59, -6.52, 37.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aed3f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88adf1"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "Computer_02b",
    "data-name": "Computer_02b",
    viewBox: "0 0 107.73 100.66"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.99 36.51 5.99 93.21 107.73 60.16 107.73 3.46 5.99 36.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 33.06 5.99 36.51 107.73 3.46 101.74 0 0 33.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 33.06 5.99 36.51 5.99 93.21 0 89.76 0 33.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23.94 92.78 32.92 97.96 89.77 79.49 80.8 74.31 23.94 92.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "23.94 92.78 23.94 95.48 32.92 100.66 32.92 97.96 23.94 92.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "89.77 79.49 89.77 82.19 32.92 100.66 32.92 97.96 89.77 79.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "53.86 77.66 53.86 88.46 62.84 85.54 62.84 74.74 53.86 77.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "50.87 78.63 50.87 86.73 53.86 88.46 53.86 77.66 50.87 78.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "11.97 39.97 11.81 86.07 101.3 56.89 101.74 10.8 11.97 39.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "17.41 44.89 17.37 60.41 41.63 52.49 41.75 36.98 17.41 44.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "17.37 63.1 17.33 64.95 41.59 57.04 41.71 55.2 17.37 63.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "17.37 67.3 17.33 69.14 41.59 61.23 41.71 59.39 17.37 67.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "17.37 71.48 17.33 73.33 41.59 65.42 41.71 63.58 17.37 71.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "17.37 75.67 17.33 77.52 41.59 69.61 41.71 67.77 17.37 75.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "45.1 53.72 45.05 69.23 69.32 61.32 69.44 45.81 45.1 53.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "45.05 35.42 45.01 37.27 69.27 29.36 69.39 27.51 45.05 35.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "45.05 39.61 45.01 41.46 69.27 33.55 69.39 31.7 45.05 39.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "45.05 43.8 45.01 45.65 69.27 37.74 69.39 35.89 45.05 43.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "45.05 47.99 45.01 49.84 69.27 41.93 69.39 40.08 45.05 47.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "72.89 44.1 72.84 45.95 97.11 38.04 97.23 36.19 72.89 44.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "72.89 48.29 72.84 50.14 97.11 42.23 97.23 40.38 72.89 48.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "72.89 52.48 72.84 54.33 97.11 46.42 97.23 44.57 72.89 52.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "72.89 56.67 72.84 58.52 97.11 50.61 97.23 48.76 72.89 56.67"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kontor_Lager",
    "data-name": "Kontor & Lager"
  }, /*#__PURE__*/React.createElement("use", {
    width: 107.73,
    height: 100.66,
    xlinkHref: "#Computer_02b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor2);
export default __webpack_public_path__ + "static/media/monitor-2.a2a4b95cb695bbd673f1f4b307362c4e.svg";
export { ForwardRef as ReactComponent };